import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { MenuItem, Select, AppBar, IconButton, Menu } from "@material-ui/core";
import smartParkService from "../../../axios";
import { makeStyles } from "@material-ui/core/styles";
import { AccountCircle, ExpandMore } from "@material-ui/icons";
import _ from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import Auth from "../../../Auth";
import {
  login_,
  unmountLogin,
  usersessionid_,
  token_,
} from "../../../reducers/login";
import {
  permissions_,
  unmountPermissions,
  Getaccesspermissions,
  hasLoadedpermissions_,
} from "../../../reducers/permissions";
import { hasFeature, subscriptionType } from "../../../utils/features";
import NotifyMe from "../../NotifyMe";
import { isAdminPath } from "../../../utils/checkAdminPath";

const headerHidden = ["/login"];

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& .MuiOutlinedInput-input": {
      padding: "5px !important",
    },
  },
  header: {},
  logo: {
    backgroundColor: "#fff",
    padding: 5,
    float: "left",
    "& img": {
      width: 150,
      height: 46,
      [theme.breakpoints.down("md")]: {
        width: 100,
        height: 30,
      },
    },
  },
  collapseMenu: {
    marginLeft: 10,
  },
  select: {
    border: "1px solid #8f9598",
    borderRadius: 4,
    borderBottom: "none",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  appBar: {
    zIndex: 1210,
    backgroundColor: "#FFF",
    color: "#03354b",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 2px 2px rgba(0,0,0,.03), 0 1px 0 rgba(0,0,0,.03)",
    [theme.breakpoints.down("sm")]: {
      "& h6": { fontSize: "x-small !important" },
      "& .MuiInputBase-root": { fontSize: "x-small !important" },
      "& .MuiMenuItem-root": { fontSize: "x-small !important" },
    },
  },
  navBarMenu: {
    display: "flex",
    float: "right",
    height: "65px",
    justifyContent: "center",
  },
  hide: {
    display: "none",
  },
  sm_hide: {
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
}));

const ParkHeader = ({ parkname, logo, parks }) => {
  const loginDetails = useSelector(login_);
  const ParkID = _.get(loginDetails, ["parkID"], "");
  const userid = _.get(loginDetails, ["UserID"], "");
  const usersessionid = useSelector(usersessionid_);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [currentPage, setCurrentPage] = useState("overview");
  const [notifyMeModal, setNotifyMeModal] = useState(false);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const firstName = _.get(loginDetails, ["FirstName"], "");
  const emailAddress = _.get(loginDetails, ["EmailAddress"], "");
  const isMenuOpen = Boolean(anchorEl);
  const dispatch = useDispatch();

  const renderHeader = useCallback((pathname) => {
    return !headerHidden.some((page) => pathname.startsWith(page));
  }, []);
  const handleCloseEvent = () => {
    setNotifyMeModal(false);
  };
  const handleMenuClose = () => {
    // history.push("/UserProfile?id=" + userid);
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const history = useHistory();
  const location = useLocation();
  const setprofilename = () => {
    // const user= JSON.parse(localStorage.getItem('user'))
    if (!firstName && emailAddress) return emailAddress.split("@")[0];
    else return firstName;
  };
  useEffect(() => {
    const { pathname } = location;
    setIsAdmin(isAdminPath(pathname));
    setShowHeader(renderHeader(pathname));
    let variable;
    if (pathname.startsWith("/admin/")) {
      variable = pathname.slice("/admin/".length);
    } else {
      variable = "overview";
    }

    setCurrentPage(variable);
  }, [location]);

  const navigatePage = ({ pathname }) => {
    history.push(pathname);
  };
  const menuOptions = [
    {
      name: "My Account",
      url: ``,
      action: () => {
        navigatePage({ pathname: `/myaccount?id=${userid}` });
      },
    },
    {
      name: "Logout",
      url: `/Logout`,
      action: () => {
        Logout();
      },
    },
  ];
  const Logout = async () => {
    var url = "api/park/" + ParkID + "/usersessions/";
    await smartParkService
      .post(url + usersessionid)
      .then((res) => {
        if (res.data.status == 200) {
          dispatch(unmountLogin());
          dispatch(unmountPermissions());
          history.push("/");
          Auth.signout();
        }
      })
      .catch((error) => {
        dispatch(unmountLogin());
        Auth.signout();
        history.push("/");
      });
  };
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id="primary-search-account-menu"
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {menuOptions.map(({ name, url, action }, index) => {
        return (
          <MenuItem
            key={index}
            onClick={() => {
              action();
              handleMenuClose();
            }}
          >
            {name}
          </MenuItem>
        );
      })}
    </Menu>
  );

  return (
    <div className={classes.header}>
      {showHeader && (
        <>
          <AppBar position="fixed" className={classes.appBar}>
            <div
              onClick={() => {
                navigatePage({
                  pathname: isAdminPath(history.location.pathname)
                    ? "/overview"
                    : "/",
                });
              }}
              style={{
                cursor: "pointer",
                height: "60px",
                marginLeft: 10,
                flex: 1,
                display: "flex",
                alignItems: "center",
                flexBasis: 0,
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{
                  width: "auto",
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "60px",
                }}
              />
            </div>
            <div
              style={{
                flex: 2,
                alignContent: "center",
                flexBasis: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h4 class="dbtitle marB0">{parkname}</h4>
                {isAdmin && (
                  <Select
                    style={{ maxWidth: "300px" }}
                    fullWidth
                    size="small"
                    labelId="label"
                    value={currentPage}
                    onChange={(e) => {
                      if (e.target.value === "overview") {
                        navigatePage({ pathname: "/overview" });
                      } else {
                        navigatePage({ pathname: "/admin/" + e.target.value });
                      }
                    }}
                  >
                    <MenuItem value="overview" id="overview">
                      Overview
                    </MenuItem>
                    {parks?.map((park) => {
                      return (
                        <MenuItem
                          key={park.park_id}
                          value={park.park_name.toLowerCase()}
                          id={park.park_id}
                        >
                          {park.park_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                )}
              </div>
            </div>
            <div
              style={{
                flex: 1,
                justifyContent: "flex-end",
                flexBasis: 0,
              }}
              className={classes.navBarMenu}
            >
              {isAdmin ? (
                <IconButton
                  style={{
                    visibility: isAdmin ? "visible" : "hidden",
                  }}
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={"primary-search-account-menu"}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                >
                  <AccountCircle fontSize="large" /> &nbsp;
                  <span class="user-info display-xs-0">
                    <h6>{setprofilename()}</h6>
                    <span>Profile Details</span>
                  </span>
                  <ExpandMore className={classes.sm_hide} />
                </IconButton>
              ) : hasFeature({
                  feature: "NotifiyMe",
                  subscriptionType: subscriptionType,
                }) ? (
                <div className={`desktopicon ${classes.sectionDesktop}`}>
                  <MenuItem onClick={() => setNotifyMeModal(true)}>
                    <div style={{ margin: "20px" }} color="secondary">
                      <b>Notify Me</b>
                    </div>
                  </MenuItem>
                </div>
              ) : (
                ""
              )}
            </div>
            {renderMenu}
          </AppBar>
          {hasFeature({
            feature: "NotifiyMe",
            subscriptionType: subscriptionType,
          }) && (
            <NotifyMe
              modalStatus={notifyMeModal}
              closeModalHandler={handleCloseEvent}
              parkArray={parks}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ParkHeader;
